import { useNavigate } from "react-router-dom";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import FolderDialog from "./FolderDialog";
import LibraryToolbar from "./LibraryToolbar";
import LibraryWorkspace from "./LibraryWorkspace";
import SendCollegeDocumentsDialog from "./SendCollegeDocumentsDialog";
import { useDocumentLibrary } from "./useDocumentLibrary";

/**
 * The Library tab's own component so `useDocumentLibrary` mounts with it. Calling that hook up in
 * the page would fire the folder and file queries even when the Sent documents tab is the one on
 * screen, which is exactly what a notification deep-link into `.../documents/sent` does.
 */
const LibraryTab = ({ universityId }) => {
  const navigate = useNavigate();
  const { toolbar, folderTree, content, dialog, sendDialog, confirmDelete } = useDocumentLibrary(
    universityId,
    navigate
  );

  return (
    <>
      <LibraryToolbar {...toolbar} />
      <LibraryWorkspace folderTree={folderTree} content={content} />
      <FolderDialog {...dialog} />
      <SendCollegeDocumentsDialog {...sendDialog} />
      <ConfirmDeleteDialog {...confirmDelete} />
    </>
  );
};

export default LibraryTab;
